import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { service } from '@ember/service';

export default Controller.extend({
  router: service(),
  uploadContacts: service(),
  errorMessage: null,

  reset() {
    set(this, 'errorMessage', null);
  },

  next: action(function () {
    this.router.transitionTo('funds.fund.contacts.upload.save');
  }),
});
